
import React, { useState,useEffect,useContext,useRef  } from "react";
import ReactGA from 'react-ga4';
import Modal from "react-bootstrap/Modal";
import Lang from '../lang/translations';
import Button from 'react-bootstrap/Button'
import FormCities from '../form/formSelectCity'
import FormAgeSelection from '../form/FormAgeSelection'
import helpers from '../_helpers/helpersFunction'
import Spinner from '../spinner/spinner';
import Context from '../context/context';
import { useNavigate,Link,useParams  } from 'react-router-dom';


import SceltaCanaleNotifiche from './component/scelta_canale_notifiche'
import PromoOffer from './component/promo_offer'


export default function PopupGenerico(props) {
	
  const  context = useContext(Context)
  let navigate = useNavigate();
 


 
  function StampaBottoni(props){
    if(props.contenuto.bottoni.length > 0){
      var bottoni = []
      for(let i=0;i<props.contenuto.bottoni.length;i++){
        if(props.contenuto.bottoni[i].redirect){
          bottoni.push('<Button onClick={() => {navigate({pathname: '+props.contenuto.bottoni[i].redirect+'});props.onHide()}}><i class="fa-regular fa-credit-card"/>'+props.contenuto.bottoni[i].testo+'</Button>')
        }else{
          bottoni.push('<Button onClick={() => {props.onHide()}}><i class="fa-regular fa-credit-card"/>'+props.contenuto.bottoni[i].testo+'</Button>')
        }
        
      }
    }
    return bottoni
  }


      if(props.provenienza == "unsubscribe"){
        return (<div>
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          dialogClassName="popupgenerico"
          animation={false}
          >
            <Modal.Header closeButton>
            <h4>{props.contenuto.header}</h4>
            </Modal.Header>
            <Modal.Body>
              <h3>{props.contenuto.title}</h3>
          <h4>{props.contenuto.descrizione}</h4>
            </Modal.Body>
            <Modal.Footer>
          <Button onClick={() => {props.onHide()}}><i className="fa fa-comments"/> CLOSE</Button>
          <p onClick={() => {props.onUnsub()}}><Lang w={"disiscrizione"} page={"profilo"}/></p>
          
          </Modal.Footer>
          </Modal>
        </div>)
      }


      if(props.provenienza == "scelta_canale_notifiche"){
        return <SceltaCanaleNotifiche {...props} />
      }
      

      if(props.provenienza == "disattiva_profilo"){
        console.log("Disattivazione profilo",props.contenuto.bottoni)
        return (<div>
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          dialogClassName="popupgenerico"
          animation={false}
    
          >
            <Modal.Header closeButton>
            <h4>{props.contenuto.header}</h4>
            </Modal.Header>
            <Modal.Body>
              {props.contenuto.title && (<h3 class="titolo_popup_generico">{props.contenuto.title}</h3>)}
              
          <h4>{props.contenuto.descrizione}</h4>
            </Modal.Body>
            <Modal.Footer>
              {props.contenuto.bottoni && props.contenuto.bottoni.map(function(el) {

                    return ( <Button onClick={() => {
                        if(el.data == "procedi"){
                          props.onDisattivaProfilo()
                        }else{
                          props.onHide()
                        }}}><i class={el.icona}/> {el.testo}</Button>
                      )
                    
                      
              
              })
              
              }

            
          
          
          </Modal.Footer>
          </Modal>
        </div>)
      }
      
      
      
      if(props.provenienza == "cambia_regione"){
        
     

        return (<div>
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          dialogClassName="popupgenerico"
          animation={false}
          >
            <Modal.Header closeButton>
            <h4><Lang w={"seleziona_regione"} page={"searchFilters"}/></h4>
            </Modal.Header>
            <Modal.Body>
            <label><Lang w={"titolo_popup"} page={"searchFilters"}/></label>
              <FormCities onChange={()=>{return}}/>
              <FormAgeSelection onChange={()=>{return}}/>
            </Modal.Body>
            <Modal.Footer>
            
            <Button onClick={() => {props.onHide()}}><i className="fa fa-comments"/> <Lang w={"continua"} page={"popupHook"}/></Button>

          </Modal.Footer>
          
          </Modal>
        </div>)
      }
      
      
      
      
      if(props.provenienza == "blocked"){
        return (<div>
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            fullscreen={true}
            backdrop="static"
            dialogClassName="popupgenerico"
            animation={false}
    
          >
            
            <Modal.Body>
              {props.contenuto.title && (<h3 class="titolo_popup_generico">{props.contenuto.title}</h3>)}
             

              {props.contenuto.icona && (
                  <div className="icona_popup_generico"  style={{textAlign:"center",margin:"30px"}}>
                   <img  width={"60px"} src={props.contenuto.icona} alt="Icon" />
                 </div>
              )}

              <h4 style={{textAlign:"center",color:props.contenuto.colore}} dangerouslySetInnerHTML={{__html:props.contenuto.descrizione}}></h4>

              {props.contenuto.messaggio && (
                 <div className="messaggio_pupup_generico" style={{textAlign:"center"}}>
                    <div dangerouslySetInnerHTML={{__html:props.contenuto.messaggio}}></div>
                 </div>
              )}

             
            </Modal.Body>
            <Modal.Footer>
              {props.contenuto.bottoni && props.contenuto.bottoni.map(function(data) {

                    return data.redirect ? (
                      <Button style={{width:"100%"}} onClick={() => {navigate({pathname: data.redirect});if(data.onclick){console.log(data.onclick);eval(data.onclick)};props.onHide();}}><i class={data.icona}/> {data.testo}</Button>
                    ):(
                      <Button onClick={() => {props.onHide()}}><i class={data.icona}/> {data.testo}</Button>
                    )
                      
              
              })
              
              }

              

            
          
          
          </Modal.Footer>
          </Modal>
        </div>)
      }

      // ---------- popup per promozioni (es: pacchettone, etc ..) con redirect sulla X di chiusura -----------

      if (props.provenienza == "ok_with_promo") {
        console.log("DENTRO POPUP GENERICO", props.contenuto)  
            return (<div>
              <PromoOffer {...props} />
        </div>)
      }

      else{
      
          return (<div>
            <Modal
              {...props}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            dialogClassName="popupgenerico"
            animation={false}
      
            >
              <Modal.Header closeButton>
              <h4>{props.contenuto.header}</h4>
              </Modal.Header>
              <Modal.Body>
                {props.contenuto.title && (<h3 class="titolo_popup_generico">{props.contenuto.title}</h3>)}
                
            <h4>{props.contenuto.descrizione}</h4>
              </Modal.Body>
              <Modal.Footer>
                {props.contenuto.bottoni && props.contenuto.bottoni.map(function(data) {

                      return data.redirect ? (
                        <Button onClick={() => {if(data.onclick){console.log(data.onclick);eval(data.onclick)};navigate({pathname: data.redirect});props.onHide();}}><i class={data.icona}/> {data.testo}</Button>
                      ):(
                        <Button onClick={() => {props.onHide()}}><i class={data.icona}/> {data.testo}</Button>
                      )
                        
                
                })
                
                }

              
            
            
            </Modal.Footer>
            </Modal>
          </div>)
      }

}






